(() => {
  const HIDDEN_CLASS = "vmf-hidden";

  const norm = (s) => (s || "").toString().trim().toLowerCase();

  function getSelectedColor() {
    // 1) Radio/Swatches (fieldset/legend)
    const fieldsets = document.querySelectorAll("fieldset");
    for (const fs of fieldsets) {
      const legend = fs.querySelector("legend");
      if (legend && norm(legend.textContent).includes("farbe")) {
        const checked = fs.querySelector('input[type="radio"]:checked');
        if (checked) return checked.value;
      }
    }

    // 2) Select Dropdowns
    const selects = document.querySelectorAll('select[name^="options["], select[data-option-position]');
    for (const sel of selects) {
      const label = document.querySelector(`label[for="${sel.id}"]`);
      if (label && norm(label.textContent).includes("farbe")) return sel.value;
    }

    // 3) Fallback: erste ausgewählte Option, die nach Farbe aussieht (letzter Ausweg)
    const anyChecked = document.querySelector('input[type="radio"]:checked');
    return anyChecked ? anyChecked.value : null;
  }

  function getMediaItems() {
    // Hauptmedien (Bilder/Videos)
    const main = document.querySelectorAll(
      "media-gallery [data-media-id], .product__media-wrapper [data-media-id], .product__media-list [data-media-id]"
    );
    // Thumbnails
    const thumbs = document.querySelectorAll(
      ".thumbnail-list [data-media-id], media-gallery .thumbnail-list [data-media-id]"
    );
    return { main: Array.from(main), thumbs: Array.from(thumbs) };
  }

  function getAltForMedia(el) {
    // Alt kann auf img oder auf button/thumbnail liegen
    const img = el.querySelector("img");
    return img ? (img.getAttribute("alt") || "") : (el.getAttribute("aria-label") || "");
  }

  function matchesColor(alt, color) {
    const a = norm(alt);
    const c = norm(color);

    // akzeptiert: "Farbe: Schwarz" oder "Schwarz"
    return a.includes(`farbe:${c}`) || a.includes(`farbe: ${c}`) || a === c || a.includes(c);
  }

  function applyFilter() {
    const color = getSelectedColor();
    const { main, thumbs } = getMediaItems();

    if (!color || !main.length) return;

    // Prüfen ob es überhaupt passende Medien gibt
    const anyMatch = main.some((el) => matchesColor(getAltForMedia(el), color));

    // Wenn keine Treffer, nicht alles verstecken -> dann alles zeigen
    if (!anyMatch) {
      [...main, ...thumbs].forEach((el) => el.classList.remove(HIDDEN_CLASS));
      return;
    }

    // Hauptmedien filtern
    main.forEach((el) => {
      const alt = getAltForMedia(el);
      el.classList.toggle(HIDDEN_CLASS, !matchesColor(alt, color));
    });

    // Thumbnails filtern
    thumbs.forEach((el) => {
      const alt = getAltForMedia(el);
      el.classList.toggle(HIDDEN_CLASS, !matchesColor(alt, color));
    });

    // Optional: wenn gerade ein verstecktes Medium aktiv ist, auf erstes sichtbares springen
    const gallery = document.querySelector("media-gallery");
    if (gallery) {
      const firstVisible = main.find((el) => !el.classList.contains(HIDDEN_CLASS));
      const activeHidden = gallery.querySelector("[data-media-id].is-active, [data-media-id][aria-current='true']");
      if (activeHidden && activeHidden.classList.contains(HIDDEN_CLASS) && firstVisible) {
        const id = firstVisible.getAttribute("data-media-id");
        const thumbBtn =
          document.querySelector(`.thumbnail-list [data-media-id="${CSS.escape(id)}"] button`) ||
          document.querySelector(`.thumbnail-list [data-media-id="${CSS.escape(id)}"]`);
        if (thumbBtn) thumbBtn.click();
      }
    }
  }

  function ensureStyles() {
    if (document.getElementById("vmf-style")) return;
    const style = document.createElement("style");
    style.id = "vmf-style";
    style.textContent = `
      .${HIDDEN_CLASS}{display:none!important}
    `;
    document.head.appendChild(style);
  }

  function init() {
    ensureStyles();
    applyFilter();

    // Reagiere auf alle Variant-Änderungen (Radio/Select)
    document.addEventListener("change", (e) => {
      if (
        e.target.matches('input[type="radio"][name^="options["]') ||
        e.target.matches('select[name^="options["]') ||
        e.target.closest("variant-selects") ||
        e.target.closest("variant-radios")
      ) {
        setTimeout(applyFilter, 0);
      }
    });

    // Für Themes die PubSub nutzen (Dawn)
    document.addEventListener("variant:change", () => setTimeout(applyFilter, 0));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
